import get from 'lodash.get';

const getColorPaletteTemplate = (state) =>
  get(state, 'ws.template.meta.customization.colorPaletteTemplate', '');

export default getColorPaletteTemplate;
